import { ServiceContentById } from '@/api';
import { CartItemDetails } from '@/base-api/types';

import { CartWidgetInner } from './cart-widget-inner';

interface CartWidgetWrapperInput {
  cartId: string;
  serviceContentById: ServiceContentById;
  cartItemDetails: CartItemDetails;
}

export function CartWidgetWrapper({
  cartId,
  serviceContentById,
  cartItemDetails,
}: CartWidgetWrapperInput) {
  const { services, variant_id } = cartItemDetails;

  return (
    <div className="widget-group widget-group--cart">
      {services.map((service) => {
        return (
          <CartWidgetInner
            key={service.id}
            cartId={cartId}
            serviceContent={serviceContentById[service.id].content}
            service={service}
            variantId={variant_id}
          />
        );
      })}
    </div>
  );
}
